import React, { useState, useEffect } from "react";

const IFRAME_URL =
  "https://schoonmaakcrm.nl/api/calculator-widget?v=atelier&tenant_id=db9355ed-2129-4ab0-aca4-7323c898fe26";

const CalculatorWidget = () => {
  const [height, setHeight] = useState(600);

  useEffect(() => {
    const handleMessage = (e) => {
      if (!e.data || e.data.type !== "cccrm-widget-height") return;
      if (typeof e.data.height === "number" && e.data.height > 200) {
        setHeight(Math.max(400, e.data.height + 20));
      }
    };
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  return (
    <section
      id="calculator"
      className="py-16 sm:py-24 bg-white"
      aria-labelledby="calculator-heading"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-8 sm:mb-12">
          <span className="inline-block px-3 py-1 bg-sky-100 text-sky-700 rounded-full text-xs sm:text-sm font-semibold mb-3 sm:mb-4">
            Gratis Offerte
          </span>
          <h2
            id="calculator-heading"
            className="text-2xl sm:text-4xl lg:text-5xl font-bold text-slate-800 mb-3 sm:mb-4"
          >
            Bereken direct uw prijs
          </h2>
          <p className="text-base sm:text-lg text-slate-600 max-w-2xl mx-auto">
            Vul onderstaande gegevens in en ontvang direct een prijsindicatie.
            Geen verplichtingen, wel duidelijkheid.
          </p>
        </div>

        {/* CC CRM Calculator Widget (self-resizing via postMessage) */}
        <div className="mx-auto w-full max-w-[480px]">
          <iframe
            id="cccrm-widget"
            src={IFRAME_URL}
            title="Cleven Cleaning Prijscalculator"
            data-testid="calculator-iframe"
            loading="lazy"
            allow="geolocation; clipboard-write"
            style={{
              width: "100%",
              height: `${height}px`,
              border: 0,
              borderRadius: "28px",
              display: "block",
              transition: "height .25s ease",
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default CalculatorWidget;
